import { YesObject } from '@yes.technology/react-toolkit'
import { Array, Optional, Record, String } from 'runtypes'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'

type ImageType = {
  url: string
  alt: string
}

type SlideType = {
  des: string
  complement: string
  obs?: string
  image: {
    desktop: ImageType
    mobile: ImageType
  }
}

export type AnimationSliderType = {
  slides: SlideType[]
  subtitles: string[]
  starterPopup: {
    des: string
    complement: string
  }
  color?: string
  textColor?: string
}

export type AnimationSliderContainerType = {
  props: {
    objects?: Pick<YesObject, 'des'>[]
    color?: string
    textColor?: string
    styleMap?: StyleMap
  }
}

export const AnimationSliderContainerTypeGuard = Record({
  objects: Array(Record({ des: String })),
  color: Optional(String),
  textColor: Optional(String)
})
